module.exports = { "default": require("core-js/library/fn/object/entries"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/babel-runtime/core-js/object/entries.js
// module id = 253
// module chunks = 0